import { render, staticRenderFns } from "./FloatPanel.vue?vue&type=template&id=0a036a44&scoped=true"
import script from "./FloatPanel.vue?vue&type=script&lang=js"
export * from "./FloatPanel.vue?vue&type=script&lang=js"
import style0 from "./FloatPanel.vue?vue&type=style&index=0&id=0a036a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a036a44",
  null
  
)

export default component.exports